import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedMultiselectComponent } from './shared-multiselect/shared-multiselect.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbDatepickerModule} from "@ng-bootstrap/ng-bootstrap";
import {DataTablesModule} from "angular-datatables";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import {MultiSelectAllModule} from "@syncfusion/ej2-angular-dropdowns";
import {ButtonModule, CheckBoxModule} from "@syncfusion/ej2-angular-buttons";
import {NumericTextBoxModule} from "@syncfusion/ej2-angular-inputs";
import {Ng4LoadingSpinnerModule} from "ng4-loading-spinner";
import {MatMenuModule} from "@angular/material/menu";
import {MatTabsModule} from "@angular/material/tabs";
import {CardModule} from "../theme/shared/components";
import {MatTableModule} from "@angular/material/table";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {MatStepperModule} from "@angular/material/stepper";
import {MatProgressBarModule} from "@angular/material/progress-bar";



@NgModule({
  declarations: [SharedMultiselectComponent],
  exports: [
    SharedMultiselectComponent,
    SharedMultiselectComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDatepickerModule,
    DataTablesModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    NgMultiSelectDropDownModule,
    MultiSelectAllModule,
    CheckBoxModule,
    ButtonModule,
    NumericTextBoxModule,
    Ng4LoadingSpinnerModule.forRoot(),
    MatMenuModule,
    MatTabsModule,
    CardModule,
    MatTableModule,
    PdfViewerModule,
    MatStepperModule,
    MatProgressBarModule
  ]
})
export class SharedComponentModule { }
